// --------------------------------------------------------
// UNIT LIST - UnitList
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
import React, { useCallback, useEffect, useState } from 'react'
import CompanyListItem from '../../components/companyListItem/CompanyListItem';
import ItemList from '../../components/itemList/ItemList';
import LabelInput from '../../components/labelInput/LabelInput';
import ContainerWithSidebar from '../../components/UI/containerWithSidebar/ContainerWithSidebar';
import { Text } from '../../components/UI/generalLayout/Layout.styled';
import { CompanyListItemContainer } from '../company/CompanyList.styled';
import SearchIcon from '@mui/icons-material/Search';
import * as unitActions from '../../store/actions/unit';
import { useAppDispatch } from '../..';
import { useSelector } from 'react-redux';
import Unit from '../../models/core/unit/Unit';
import { useNavigate } from 'react-router-dom';
import { Paths } from '../../enums/Paths';
import Colors from '../../constants/Colors';
import ScreenHeader from '../../components/UI/screenHeader/ScreenHeader';

// --------------------------------------------------------
// UNIT LIST INTERFACE
// --------------------------------------------------------


/**
 * A component that renders a Screen.
 *
 * @param props Properties
 * @param props.route The route
 * @param props.navigation The navigator
 * @returns The component JSX.
 */
function UnitList(): JSX.Element {
    // --------------------------------------------------------
    // UNIT LIST PRIVATE DECLARATIONS
    // --------------------------------------------------------
    const units: Unit[] = useSelector((state: any)=>state.unit.units)
    const [unitListHeaderFields] = useState([{name: 'Nome', width: '45%', align: null}, {name: 'CNPJ', width: '15%', align: null}, {name: 'Ativar/Desativar', width: '30%', align: 'right'}])

    const [searchUnitQuery, setSearchUnitQuery] = useState('')
    const dispatch = useAppDispatch()
    const navigate = useNavigate()

    const fetchUnits = useCallback(async ()=>{
        await dispatch(unitActions.fetchUnitList())
    }, [dispatch])

    const filterUnits = useCallback(async ()=>{
        if(searchUnitQuery.length >= 3 || searchUnitQuery === ''){
            await dispatch(unitActions.filterUnitList(searchUnitQuery))
        }
    }, [searchUnitQuery])

    useEffect(()=>{
        fetchUnits()
    }, [])

    useEffect(()=>{
        filterUnits()
    }, [searchUnitQuery])

    const navigateToEditUnit = (unit: Unit)=>{
        return navigate(Paths.RegisterUnit, { state: { unit: unit } })
    }

    const navigateToUnitDetail = (unit: Unit)=>{
        return navigate(Paths.RegisterUnit, { state: { unit: unit, isView: true } })
    }

    const navigateToRegisterUnit = ()=>{
        return navigate(Paths.RegisterUnit)
    }

    const activateOrInactivateUnit = async (id: string, isActive: boolean)=>{
        await dispatch(unitActions.activateOrDeactivateUnit(id, isActive))
        fetchUnits();
    }

    return <ContainerWithSidebar>
        <ScreenHeader 
            screenTitle={'Unidades cadastradas'} 
            rightButtonText={'Cadastrar nova unidade'} 
            onRightButtonClick={navigateToRegisterUnit} 
        />
        <LabelInput
            value={searchUnitQuery}
            placeholder="Busca de Unidade"
            onChangeText={(event: any) => { setSearchUnitQuery(event.target.value) }}
            rightIcon={<SearchIcon />}
        />

        {searchUnitQuery.length > 0 && (<div style={{ paddingLeft: 12, paddingRight: 12 }}><Text color={Colors.lightBlue}>Resultados para: {searchUnitQuery} </Text></div>)}

        <ItemList list={units} listHeader={unitListHeaderFields}>
            <CompanyListItemContainer>
                {units.map((unit: Unit, index: number) => {
                    return (
                    <React.Fragment key={unit.id}>
                        <CompanyListItem
                            isCompany={false}
                            name={unit.nomeFantasia}
                            id={unit.id}
                            cnpj={unit.cnpj}
                            isActiveRegister={!unit.inativo}
                            onEdit={() => {
                                navigateToEditUnit(unit);
                            }}
                            onView={() => {
                                navigateToUnitDetail(unit);
                            }}
                            onActivateInactivate={activateOrInactivateUnit} onOrpenConfig={undefined}  />
                    </React.Fragment>
                    )
                })}
            </CompanyListItemContainer>
        </ItemList>
    </ContainerWithSidebar>;
}

export default UnitList;
